export default __webpack_public_path__ + "static/media/left.85cbdf97.svg";